var HeadersTunnel = require('v4-stack/headers-tunnel');
var Message = require('v4-stack/message');

var log = require('util/logger').create('V4 Client Routing');

module.exports = function TopicRouting(session, serviceAdapter, conversationSet, cache, registry) {
    this.route = function(message) {
        if (message.isTopicMessage()) {

            if (message.type === Message.types.FETCH_REPLY) {
                var cid = HeadersTunnel.cidFromHeaders(message.headers);
                conversationSet.respond(cid, message.topic, message.data);
            } else if (message.type === Message.types.TOPIC_LOAD) {
                cache.handleValue(session, message.topic, message.data, registry);
            } else if (message.type === Message.types.DELTA) {
                cache.handleDelta(session, message.topic, message.data, registry);
            } 
        }
        else if (message.isServiceMessage()) {
            serviceAdapter.onMessage(message.type, message.getInputStream());
        }
        else {
            log.debug('Unhandled V4 message: ' + message.type, message);
        }
    };

    this.subscribe = function(info) {
        cache.handleSubscription(info, registry);
    };

    this.unsubscribe = function(id, reason) {
        cache.handleUnsubscription(id, reason, registry);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/routing/topic-routing.js
// module id = 996
// module chunks = 1